<template>
  <div style="height: 100%">
  <button class="sidebar-button slds-button slds-button_icon" :class="{'collapsed': collapsed}" @click="collapse" title="Collapse">
    <svg class="slds-button__icon" aria-hidden="true">
      <use xlink:href="../assets/symbols.svg#play"></use>
    </svg>
    <span class="slds-assistive-text">Collapse</span>
  </button>
  </div>
</template>
<script>
export default {
  props: {
    collapsed: Boolean
  },
  methods: {
    collapse () {
      this.$emit('collapse')
    }
  }
}
</script>
<style lang="scss">
.sidebar-button {
  transform: rotate(180deg);
  height: 100%;
  border-top: 1px solid #DDDBDA !important;
  border-bottom: 1px solid #DDDBDA !important;
  border-right: 1px solid #DDDBDA !important;
  border-left: 0px !important;

  &.collapsed {
    transform: rotate(0);
  }
}
</style>
